module.exports = __webpack_public_path__ + "img/shop.275295aa.png";